import React from 'react';
import { Header, Paragraph, Section } from '../components/Typography';

const CheckEmail = () => (
  <Section>
    <Header>So you are ready to become an AI trainer? Great!</Header>
    <Paragraph>
      We’ve just sent you a confirmation email. In that email there is a link,
      and that link takes you to a web page where you can sign-up to get access
      to a platform that is dedicated solely to train for the AI trainer
      onboarding.
    </Paragraph>
    <Paragraph>
      All we need is your full name and then you can select which date for your
      14-day access to start. We advise you to do this as soon as possible, so
      you don't have to wait more than a couple of days to get access.
    </Paragraph>
  </Section>
);

export default CheckEmail;
